import type { AggregatedMetricsData } from './aggregatedMetricsData';

export interface AggregatedMetrics {
  data?: AggregatedMetricsData;
  endDate?: string;
  startDate?: string;
  userId?: string;
}
